import { inject, Injectable } from '@angular/core';
import {
  Router,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
  CanActivateFn,
} from '@angular/router';
import { AuthService } from 'src/app/public/auth/auth.service';
import { PublicRoutes } from 'src/app/public/public.routes';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }
  const redirectUrl = state.url;

  router.navigate([PublicRoutes.Signin], {
    queryParams: { returnUrl: redirectUrl },
  });

  return false;
};
